// extracted by mini-css-extract-plugin
module.exports = {"App":"App_App__16ZpL","slide":"App_slide__1owCH","button":"App_button__13pio"};